<template>
    <div class="faq-section roadmap-step">
        <div
            class="hidden-anchor"
            :id="'roadmap-step-' + stepIn.id"></div>
        <div
            class="page-header"
            role="tab">
            <b-button
                class="btn-page-content-toggle"
                @click="collapse()"
                :class="collapsed && 'active'"
                block
                variant="outline-primary">
                <div class="title">
                    <div
                        class="page-title"
                        v-if="stepIn.title">
                        {{ stepIn.title }}
                    </div>

                    <div
                        class="page-title"
                        v-else>
                        {{ $t('roadmap.step') }} {{ stepIn.order }}
                    </div>
                </div>

                <i class="fas fa-fw fa-chevron-down state-icon"></i>

                <div class="context-nav context-step-page-nav">
                    <b-dropdown
                        class="ellipsis-nav bordered-menu step-page-nav"
                        no-caret
                        variant="primary"
                        right
                        toggle-class="step-page-context-menu">
                        <template v-slot:button-content>
                            <i class="fas fa-ellipsis-v"></i>
                        </template>

                        <b-dropdown-item
                            class="edit-step"
                            @click.prevent.stop="changeStepTitle()">
                            <i class="btn-edit"></i>
                            {{ $t('roadmap.edit_step') }}
                        </b-dropdown-item>

                        <b-dropdown-item
                            class="remove-step"
                            @click.prevent.stop="deleteStep()">
                            <i class="btn-remove"></i>
                            {{ $t('roadmap.delete_step') }}
                        </b-dropdown-item>

                        <design-2021-roadmap-step-edit-title-modal-component
                            :step-in="stepIn"
                            ref="roadmap-step-title-edit-modal"></design-2021-roadmap-step-edit-title-modal-component>
                    </b-dropdown>
                </div>
            </b-button>
        </div>

        <div class="col-12">
            <b-collapse
                class="accordion roadmap-step-content"
                v-model="collapsed"
                :id="`roadmap-step-${stepIn.id}`"
                role="tabpanel">
                <div class="form-group group-description">
                    <label class="group-description-label">{{ $t('common.description') }}</label>
                    <div class="description">
                        <ckeditor
                            v-model="description"
                            :editor="editor"
                            :config="editorConfig"
                            :placeholder="$t('common.description')">
                        </ckeditor>
                    </div>
                </div>

                <div class="form-group group-deadline">
                    <label class="group-deadline-label">Deadline</label>
                    <b-form-datepicker
                        class="apprentice-date-picker btn-deadline-group"
                        v-model="deadlineDate"
                        start-weekday="1"
                        reset-button
                        right
                        locale="nl"
                        nav-button-variant="primary"
                        :aria-controls="$t('roadmap.choose_deadline')"
                        label-reset-button="reset"
                        :label-no-date-selected="$t('roadmap.no_deadline_selected')"
                        menu-class="datedropdown deadlinedropdown"
                        :date-format-options="{ year: 'numeric', month: 'numeric', day: '2-digit' }"
                        @input="setDeadlineDate">
                    </b-form-datepicker>

                    <design2021-apprentice-timepicker-component
                        v-model="time"
                        @input="setDeadlineTime">
                    </design2021-apprentice-timepicker-component>
                </div>

                <div class="new-page-container">
                    <b-button
                        variant="primary"
                        @click="setDescription">
                        {{ $t('common.save') }}
                    </b-button>
                </div>
            </b-collapse>
        </div>
    </div>
</template>

<script>
import moment from 'moment';
import ApprenticeEditor from '../../helpers/ApprenticeEditor';
import { ords } from '../../app';
import Design2021ApprenticeTimepickerComponent from '../common/input/design-2021-apprentice-timepicker-component.vue';

export default {
    name: 'design-2021-roadmap-create-step-component',
    components: { Design2021ApprenticeTimepickerComponent },
    props: ['stepIn', 'roadmapIn'],
    data() {
        return {
            description: this.stepIn.description === null ? '' : this.stepIn.description,
            dateConfig: {
                format: 'DD-MM-YYYY',
                useCurrent: false,
            },
            deadlineDate: this.stepIn.deadline == null ? '' : this.stepIn.deadline.date,
            editor: ApprenticeEditor,
            time: this.stepIn.deadline == null ? '' : this.stepIn.deadline.time,
            editorConfig: {
                contentsCss: 'test',
                placeholder: this.$t('common.description'),
                bodyClass: 'mybodyclass',
                toolbar: {
                    items: [
                        'heading',
                        '|',
                        'bold',
                        'italic',
                        'underline',
                        '|',
                        'link',
                        'bulletedList',
                        'numberedList',
                        'undo',
                        'redo',
                    ],
                },
                language: this.$authUser.locale,
                table: {
                    contentToolbar: ['tableColumn', 'tableRow', 'mergeTableCells'],
                },
            },
            collapsed: false,
        };
    },
    methods: {
        collapse() {
            this.collapsed = !this.collapsed;
            const name = 'roadmap-edit-collapse-' + this.stepIn.id;
            localStorage.setItem(name, this.collapsed ? 1 : 0);
        },
        setDescription() {
            let data = {
                id: this.stepIn.id,
                description: this.description,
            };

            this.alert.saving();

            this.axios.post(this.routes.roadmapStepDescription(), data).then(
                (response) => {
                    this.stepIn.update({ description: this.description });

                    this.alert.success();
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },
        setDeadlineDate(date) {
            this.deadlineDate = date;
            this.setDeadline();
        },
        setDeadlineTime(time) {
            this.deadlineTime = time;
            this.setDeadline();
        },
        setDeadline() {
            let deadline = moment(this.deadlineDate).format('DD-MM-YYYY');

            let data = {
                id: this.stepIn.id,
                deadlineDate: deadline,
                deadlineTime: this.time,
            };

            this.axios.post(this.routes.roadmapStepDeadline(), data).then(
                (response) => {},
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },
        deleteStep() {
            this.alert
                .confirm(this.$t('roadmap.delete_step'), this.$t('roadmap.are_you_sure_you_want_to_delete_this_step'))
                .then((confirm) => {
                    if (!confirm) {
                        return;
                    }

                    this.alert.saving();

                    this.axios.delete(this.routes.roadmapStepDelete(this.stepIn.id)).then(
                        (response) => {
                            ords.hold();

                            this.roadmapIn.detach(this.roadmapIn.id, 'steps', this.stepIn.id);
                            this.stepIn.remove();

                            for (const roadmap_step of this.roadmapIn.steps) {
                                for (const step of response.data.steps) {
                                    if (step.id === roadmap_step.id) {
                                        roadmap_step.update({ order: step.order });
                                    }
                                }
                            }

                            ords.continue();
                            this.alert.success();
                        },
                        (error) => {
                            this.alert.ajaxError(error);
                        },
                    );
                });
        },
        changeStepTitle() {
            this.$refs['roadmap-step-title-edit-modal'].show();
        },
    },
    mounted() {
        const name = 'roadmap-steps-collapse-' + this.stepIn.id;
        if (localStorage.getItem(name) !== null) {
            this.collapsed = !!parseInt(localStorage.getItem(name));
        } else if (this.stepIn.order === 1) {
            this.collapsed = true;
        }
    },
};
</script>

<style scoped lang="scss">
.page-header {
    padding: 0;
    margin-bottom: 0;
    min-height: unset;
}

.roadmap-step {
    margin-bottom: map-get($grid-gutter-spacing, 'fifteen');

    .btn-page-content-toggle {
        justify-content: space-between;
        border: 1px solid $primary;
        outline: none;
        box-shadow: none;
        border-radius: $border-radius-content;
        line-height: 1;

        &,
        .title {
            display: flex;
            flex-direction: row;
            align-items: center;
        }

        .state-icon {
            transform-origin: center;
            transition: all 0.8s ease;
            margin-left: auto;
            margin-right: map-get($grid-gutter-spacing, 'fifteen');
        }

        &:hover {
            background-color: $info;
            font-weight: $font-weight-bold;

            &,
            .step-drag-handle {
                color: $white;
            }
        }

        &.active {
            background-color: $info;
            font-weight: $font-weight-bold;
            color: $white;
            border: 1px solid $info;

            .state-icon {
                transform: rotate(-180deg);
            }
        }
    }

    .page-content {
        margin-top: map-get($grid-gutter-spacing, 'fifteen');
        margin-bottom: map-get($grid-gutter-spacing, 'fifteen');

        div:first-child {
            > div:last-child {
                .assignment-question-header {
                    border-bottom-color: transparent;
                }
            }
        }

        .assignment ::v-deep {
            flex: 1 0 100%;

            .context-assignment-part-nav {
                position: relative;
                right: -5px;
            }
        }

        .explanation,
        .assignment {
            display: flex;
            flex-direction: row;
            align-items: center;
            margin-bottom: map-get($grid-gutter-spacing, 'fifteen');
            padding-right: map-get($grid-gutter-spacing, 'fifteen');
            padding-left: map-get($grid-gutter-spacing, 'fifteen');

            .drag-handle {
                margin-right: map-get($grid-gutter-spacing, 'fifteen');
                align-self: center;
                font-size: $base-font-size;
                color: $primary;

                &:hover {
                    cursor: pointer;
                }
            }
        }

        .explanation {
            .drag-handle {
                margin-left: 9px;
            }
        }

        .add-assignment-part {
            display: flex;
            align-items: center;
            justify-content: center;
            margin-top: map-get($grid-gutter-spacing, 'forty-two');
            margin-bottom: map-get($grid-gutter-spacing, 'forty-two');
        }
    }
}

.context-step-page-nav ::v-deep {
    .step-page-nav {
        .step-page-context-menu {
            line-height: 1;
        }

        .edit-step {
            i {
                color: $primary;
            }
        }

        .remove-step {
            i {
                color: $danger;
            }
        }

        .remove-step {
            font-size: $default-font-size;
        }
    }
}

.roadmap-step-content {
    .group-description {
        margin-top: map-get($grid-gutter-spacing, 'fifteen');
    }
}

.new-page-container {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: map-get($grid-gutter-spacing, 'forty-two');
}
</style>
